import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

import config from '@src/configs/aspendental';

export type State = {
	restUrl: string;
	graphUrl: string;
	googleUrl: string;
	userEventsUrl: string;
	mottoFlow: boolean;
	languageToggleEnabled: boolean;
	googleMapApiKey: string;
	isPatientServicesApp: boolean;
	eapiBaseUrl: string;
	isPatientPortalPhase2Enabled: boolean;
};

export type Actions = {
	setRestUrl: (url: string) => void;
	setGraphUrl: (url: string) => void;
	setGoogleUrl: (url: string) => void;
	setUserEventsUrl: (url: string) => void;
	setMottoFlow: (active: boolean) => void;
	setLanguageToggleEnabled: (enabled: boolean) => void;
	setGoogleMapApiKey: (apiKey: string) => void;
	setIsPatientServicesApp: (isPatientServicesApp: boolean) => void;
	setEapiBaseUrl: (url: string) => void;
	setIsPatientPortalPhase2Enabled: (enabled: boolean) => void;
};

const useAppStore = create<State & Actions>((set) => ({
	restUrl: 'https://apistg.aspendental.com/api/web/', // default to stage
	graphUrl: 'https://apistg.aspendental.com/websitegraphql/graphql/',
	googleUrl: 'https://www.google.com/maps/conversion/debug/collect', // default to stage
	mottoFlow: false,
	languageToggleEnabled: false,
	googleMapApiKey: config.services.nonprod.GOOGLE_MAP_API_KEY,
	setRestUrl: (url) => set({ restUrl: url }),
	setGraphUrl: (url) => set({ graphUrl: url }),
	setGoogleUrl: (url) => set({ googleUrl: url }),
	userEventsUrl: 'https://userevents.dataplatform.gke.us-central1.gcp.stage.aspendental.com/', // default to stage
	setUserEventsUrl: (userEventsUrl) => set({ userEventsUrl }),
	setMottoFlow: (active) => set({ mottoFlow: active }),
	setLanguageToggleEnabled: (languageToggleEnabled) => set({ languageToggleEnabled }),
	setGoogleMapApiKey: (googleMapApiKey) => set({ googleMapApiKey }),
	isPatientServicesApp: false,
	setIsPatientServicesApp: (isPatientServicesApp) => set({ isPatientServicesApp }),
	eapiBaseUrl: 'https://apistg.aspendental.com/', // default to stage
	setEapiBaseUrl: (eapiBaseUrl) => set({ eapiBaseUrl }),
	isPatientPortalPhase2Enabled: false,
	setIsPatientPortalPhase2Enabled: (enabled) => set({ isPatientPortalPhase2Enabled: enabled }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('appStore', useAppStore);
}

export default useAppStore;
